import { UploadedFiles } from "@portal/BaseComponents/Document/UplodedFiles/UploadedFiles";
import { Item, ListMeta } from "@portal/BaseComponents/List/AntList";
import { TextColumn } from "@portal/BaseComponents/Table/Components/Text/TextColumn";
import useOpen from "@portal/hooks/useOpen";
import { DocumentList } from "@portal/types/entities/documents";
import { FileType, MimeTypes, PreviewFiles } from "@portal/types/file";
import { getDocTypeIcon } from "@portal/util/docIcon";
import {
  getFileExtensionFromName,
  getFileTypeFromExtension,
} from "@portal/util/file";
import { CellRenderProps } from "@sinecycle/growcomponents";
import { message } from "antd";
import { DocumentTitleList } from "./style";

function DocumentTitle(props: CellRenderProps<DocumentList>) {
  const { data } = props;
  const { open, toggleOpen, handleOpenChange } = useOpen({ open: false });
  const [messageApi, contextHolder] = message.useMessage();
  if (!data) return;
  const fileExtension = getFileExtensionFromName(data.attachment.file_name);
  const fileType = fileExtension
    ? getFileTypeFromExtension(fileExtension)
    : FileType.PDF;

  const isPreviewFile = !PreviewFiles.includes(fileType);
  const Title = (
    <TextColumn
      text={data.name}
      type="Text"
      textProps={{
        style: {
          textAlign: "left",
          color: isPreviewFile ? "var(--gray-9)" : "var(--primary-7)",
          cursor: isPreviewFile ? "default" : "pointer",
          lineHeight: 1.5,
        },
        onClick: isPreviewFile
          ? undefined
          : () => {
              if (data.attachment.content_type === "application/pdf") {
                messageApi.loading({
                  type: "loading",
                  content: "Action in progress...",
                });
              }

              toggleOpen();
            },
        ellipsis: { tooltip: data.name },
      }}
    />
  );

  const Icon = getDocTypeIcon(MimeTypes[data.attachment.content_type]);
  const Preview = (
    <UploadedFiles
      file={data.attachment}
      previewType={"EXPIRE_LINK"}
      previewMode="HIDE"
      preview={open}
      handleOpenChange={handleOpenChange}
      onSuccess={() => {
        messageApi.destroy();
      }}
    />
  );

  return (
    <>
      {contextHolder}
      <DocumentTitleList
        dataSource={[data]}
        renderItem={(item) => {
          return (
            <Item key={item.id} style={{ lineHeight: 1.5 }}>
              <ListMeta
                avatar={[Icon]}
                title={Title}
                style={{ lineHeight: 1.5 }}
              />
              {Preview}
            </Item>
          );
        }}
      />
    </>
  );
}

export { DocumentTitle };
